const SCROLL_CONFIG = {
  HEADER_OFFSET: -100,
  MAX_RETRY_ATTEMPTS: 3,
  RETRY_DELAY_MS: 50,
};

export const scrollToElement = (id, onSuccess) => {
  const tryScroll = (attempt = 0) => {
    const el = document.getElementById(id);
    if (el) {
      const yOffset = SCROLL_CONFIG.HEADER_OFFSET;
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
      onSuccess?.();
    } else if (attempt < SCROLL_CONFIG.MAX_RETRY_ATTEMPTS) {
      setTimeout(() => tryScroll(attempt + 1), SCROLL_CONFIG.RETRY_DELAY_MS);
    }
  };
  tryScroll();
};
